'use client';
import { MouseEvent } from 'react';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { CTAButtonProps, ProductProps } from '@repo/ui/src/types';
import NotifyMeButton from './_NotifyMeButton';
import AddToCartButton from './_AddToCartButton';
import ShopLocalButton from './_ShopLocalButton';

const itemFactory = (type: 'addToCart' | 'notifyMe' | 'noCTA' | 'shopLocal') => {
  const types = {
    notifyMe: NotifyMeButton,
    addToCart: AddToCartButton,
    shopLocal: ShopLocalButton,
    noCTA: () => null,
  };
  return types[type];
};

interface Props {
  buttonProps?: CTAButtonProps;
  product: ProductProps;
  customProductPrice?: number;
  onClickAddToCart: (e: MouseEvent<HTMLElement>) => void;
  buttonProcessing?: boolean;
  processingText?: string;
  className?: string;
  disable?: boolean;
}

const CallToActionButton = ({ product, disable, ...props }: Props) => {
  const { eCommEnabled } = useCurrentUrl();
  const buttonType =
    eCommEnabled && (product.isOrderable || disable)
      ? 'addToCart'
      : (product.ctaButtonType ?? 'notifyMe');
  const ButtonComponent = itemFactory(buttonType);

  return <ButtonComponent {...props} product={product} />;
};

export default CallToActionButton;
